import { createRoot } from "react-dom/client";
import App from "./core/App";
import "./styles/index.css";

// Fail loudly if the mount point is missing, instead of passing null to createRoot
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element #root was not found in public/index.html");
}

createRoot(container).render(<App />);